import { useMutation, useQueryClient } from '@tanstack/react-query';
import { msalInstance, useAuthStore } from '@sib/auth';
import { clearLocalStorage, storageKeys } from '@sib/utils';

interface UseLogoutProps {
  onLogout?: () => void;
}

export const useLogout = ({ onLogout }: UseLogoutProps = {}) => {
  const { setAccount } = useAuthStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      clearLocalStorage({ persistValueKeys: [storageKeys.userSetupStore] });
      queryClient.clear();
      sessionStorage.clear();
      await msalInstance.logoutRedirect({
        onRedirectNavigate: () => false,
      });
      setAccount(null);

      onLogout?.();

      window.location.reload();
    },
  });
};
